import NumberValueLabel from './NumberValueLabel';

export default NumberValueLabel;
